import actions from '@/components/library/registrationForm/store/actions';
import mutations from '@/components/library/registrationForm/store/mutations';

const state = {
  formJson: null,
  formJsonLoading: false,
  formJsonError: null
};

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
